import * as React from "react";
import { useTranslation } from "react-i18next";

interface IProps {
    openAsDialog: boolean;
    continueButtonText: string;
    onContinueCallback: any;
}

const L3SuccessComponent: React.FunctionComponent<IProps> = (props) => {
    const { t: tLang, i18n: i18nLang } = useTranslation();
    let strContinueButtonText = tLang("dashboard.creditScore.l3SuccessComp.continueButtonText");
    let blnOpenAsDialog = false;

    // set default value for props, if not passed
    if (props.continueButtonText != null) {
        strContinueButtonText = props.continueButtonText;
    }
    if (props.openAsDialog != null) {
        blnOpenAsDialog = props.openAsDialog;
    }

    // in case of dialog, register event for escape press
    if (blnOpenAsDialog) {
        window.addEventListener("keyup", (evt: any) => {
            evt = evt || window.event;
            var isEscape = false;
            if ("key" in evt) {
                isEscape = evt.key === "Escape" || evt.key === "Esc";
            } else {
                isEscape = evt.keyCode === 27;
            }
            if (isEscape) {
                window.removeEventListener("keyup", () => {});
            }
        });
    }

    const invokePostSubmitCallback = (status: string, data: any) => {
        if (props.onContinueCallback != null) {
            props.onContinueCallback({ status: status, data: data });
        }
    };

    const onSubmit = () => {
        invokePostSubmitCallback("success", "Continue");
    };

    return (
        <React.Fragment>
            <div className="dialog-header">
                <div className="dialog-icon status-default">
                    <em className="las la-check-circle"></em>
                </div>
                <h2>{tLang("dashboard.creditScore.l3SuccessComp.title")}</h2>
            </div>
            <div className="dialog-body">
                <p>{tLang("dashboard.creditScore.l3SuccessComp.verifiedMsg")}</p>
            </div>
            <div className="dialog-footer">
                <div className="row between-xs">
                    <div className="col-xs col-no-gutter flex-grow-null"></div>
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <button type="button" className="btn-default btn-primary" onClick={onSubmit}>
                            <span className="btn-text">{strContinueButtonText}</span>
                        </button>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default L3SuccessComponent;
